var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLeftArrow = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 21,
    viewBox: "0 0 13 21",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1624 2.07143C12.1624 1.89062 12.082 1.72991 11.9615 1.60938L10.957 0.604909C10.8365 0.484375 10.6557 0.404016 10.495 0.404016C10.3343 0.404016 10.1535 0.484375 10.0329 0.604909L0.671317 9.96652C0.550781 10.0871 0.470424 10.2679 0.470424 10.4286C0.470424 10.5893 0.550781 10.7701 0.671317 10.8906L10.0329 20.2522C10.1535 20.3728 10.3343 20.4531 10.495 20.4531C10.6557 20.4531 10.8365 20.3728 10.957 20.2522L11.9615 19.2478C12.082 19.1272 12.1624 18.9464 12.1624 18.7857C12.1624 18.625 12.082 18.4442 11.9615 18.3237L4.06641 10.4286L11.9615 2.53348C12.082 2.41295 12.1624 2.23214 12.1624 2.07143Z",
    fill: "#CE2D50"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeftArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "1642699981952/static/media/left-arrow.22f232dd.svg";
export { ForwardRef as ReactComponent };